import React from "react";
import {
  Card,
  Rating,
  Number,
  Subtitle,
  TextContainer,
  Text,
  Header,
  HeaderContainer,
} from "./StatisticsCard.styles";

interface CardProps {
  width?: string | undefined;
  number?: string | number | undefined;
  subtitle?: string | React.ReactNode | undefined;
  text?: string | undefined;
  backgroundColor?: string | undefined;
  textColor?: string | undefined;
}

const StatisticsCard: React.FC<CardProps> = ({
  width,
  number,
  subtitle,
  text,
  backgroundColor,
  textColor,
}) => {
  return (
    <Card
      $width={width}
      $backgroundColor={backgroundColor}
      $textColor={textColor}
    >
      <HeaderContainer>
        <Header>
          <Number>{number?.toString()}</Number>
          <Rating>★★★★★</Rating>
        </Header>
        <Subtitle>{subtitle}</Subtitle>
      </HeaderContainer>
      <TextContainer>
        <Text>{text}</Text>
      </TextContainer>
    </Card>
  );
};

export default StatisticsCard;
